<div
  class="min-w-sm max-w-sm mx-auto border border-transparent bg-white rounded-lg select-none relative group-has-[.active]:bg-secondary-100 group-has-[.active]:border-secondary-200 transition-[opacity,filter] duration-300"
  [class.active]="active()"
  [class.pointer-events-none]="disabled()"
  [class.dimmed]="dimmed()"
  [class.highlighted]="highlighted()"
  [style.border]="main() ? 'none' : null"
>
  @if (main()) {
    <div
      class="absolute size-10 bg-gray-100 border-2 border-gray-500 rounded-full inset-x-0 top-0 mx-auto -translate-y-1/2 z-2 flex items-center justify-center text-gray-500 ring-4 ring-gray-100 hover:text-gray-800 hover:border-gray-800 transition-colors"
      matTooltip="Hoofdunit"
    >
      <mat-icon class="text-[1.25rem]">apartment</mat-icon>
    </div>
  } @else if (!disabled()) {
    <div
      *appHasPermission="'unit:create'"
      class="absolute size-7 p-0.5 bg-gray-100 rounded-full inset-x-0 top-0 mx-auto -translate-y-1/2 z-2 text-gray-500 hover:text-gray-800 hover:cursor-pointer transition-colors"
      role="presentation"
      matTooltip="Bovenaan toevoegen"
      (click)="addUnit.emit('top')"
    >
      <mat-icon>add_circle</mat-icon>
    </div>
  }

  <div
    class="relative z-1 flex items-center p-4"
    [class.pt-6]="!main()"
    [class.pt-8]="main()"
  >
    <div class="flex-auto px-2" [class.opacity-50]="disabled()">
      <h3 class="text-gray-800 text-lg font-medium break-all">
        {{ data().name }}
      </h3>
      @if (disabled() && data().deleteAt) {
        <p class="text-xs text-red-500 mt-1">
          Wordt verwijderd op {{ data().deleteAt | date: 'dd MMM yyyy HH:mm' }}
        </p>
      }
    </div>

    @if (disabled()) {
      <button
        *appHasPermission="'unit:delete'"
        mat-icon-button
        matTooltip="Unit herstellen"
        class="inline-flex! pointer-events-auto"
        (click)="handleRestore()"
      >
        <mat-icon>restore_from_trash</mat-icon>
      </button>
    } @else {
      <button
        *appHasPermission="'unit:update'"
        mat-icon-button
        matTooltip="Ga naar unit"
        class="inline-flex!"
        (click)="handleActivate()"
      >
        <mat-icon>login</mat-icon>
      </button>
    }
  </div>

  <mat-divider
    class="[--mat-divider-color:var(--color-gray-200)] group-has-[.active]:[--mat-divider-color:var(--color-secondary-200)]"
    [class.opacity-50]="disabled()"
  />

  @if (data().stats; as stats) {
    <div class="relative z-1 p-4 pb-8" [class.opacity-50]="disabled()">
      <div class="stats-grid px-2">
        <div class="stats-cell">
          <span class="stats-value">{{ stats.totalRobots }}</span>
          <span class="stats-label">{{ stats.totalRobots === 1 ? 'Robot' : 'Robots' }} (totaal)</span>
        </div>
        <div class="stats-cell">
          <span class="stats-value">{{ stats.unassignedRobots }}</span>
          <span class="stats-label">{{ stats.unassignedRobots === 1 ? 'Robot' : 'Robots' }} (vrij)</span>
        </div>
        <div class="stats-cell">
          <span class="stats-value">{{ stats.clientCount }}</span>
          <span class="stats-label">{{ stats.clientCount === 1 ? 'Cliënt' : 'Cliënten' }}</span>
        </div>
        <div class="stats-cell">
          <span class="stats-value">{{ stats.userCount }}</span>
          <span class="stats-label">{{ stats.userCount === 1 ? 'Gebruiker' : 'Gebruikers' }}</span>
        </div>
      </div>
    </div>
  }

  @if (!disabled()) {
    <div
      *appHasPermission="'unit:create'"
      class="absolute size-7 p-0.5 bg-gray-100 rounded-full inset-x-0 bottom-0 mx-auto translate-y-1/2 z-2 text-gray-500 hover:text-gray-800 hover:cursor-pointer transition-colors"
      role="presentation"
      [matTooltip]="main() ? 'Unit toevoegen' : 'Onderaan toevoegen'"
      (click)="addUnit.emit('bottom')"
    >
      <mat-icon>add_circle</mat-icon>
    </div>
  }
</div>
